<template>
    <div class="contact-inputs">
        <h2 class="mb-5">{{ $l10n.__('Informations de contact') }}</h2>
        <div class="flex-row">
            <el-form-item class="wp-5" prop="name" :label="$t.__('common.labels.name')">
                <el-input v-model="value.name"></el-input>
            </el-form-item>
            <el-form-item
                class="wp-5 ml-4"
                prop="forename"
                :label="$t.__('common.labels.first_name')"
            >
                <el-input v-model="value.forename"></el-input>
            </el-form-item>
        </div>

        <el-form-item
            prop="phone"
            :label="$t.__('common.labels.phone')"
            :error="errors.get('contactPhone')"
        >
            <tel-input v-model="value.phone" mode="edit" class="wp-10 contact-input-tel" />
        </el-form-item>

        <el-form-item prop="email" :label="$t.__('common.labels.email_address')">
            <el-input v-model="value.email"></el-input>
        </el-form-item>
    </div>
</template>

<script>
import TelInput from 'vcomponents/inputs/TelInput.vue';

export default {
    components: {
        TelInput,
    },
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    computed: {
        value: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;
.contact-inputs {
    .intl-tel-input,
    .intl-tel-input input {
        width: 100%;
    }

    .el-form-item.is-error .contact-input-tel input {
        border: 1px solid $red !important;
        border-radius: 5px;
    }
}
</style>
